module.exports = __webpack_public_path__ + "static/media/li-1.45f9f2c2.png";